module.exports = __webpack_public_path__ + "static/media/digital_alarm.4fdbfab.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/digital_alarm.mp3
// module id = gHaa
// module chunks = 82